<template>

</template>

<script>
export default {
    name: "Edit.vue"
}
</script>

<style scoped>

</style>
